/**
 * Item token privileges from backend (/ranch/claims privilege field).
 * See also: src/features/item_with_sinisters/docs/privileges/
 *
 * ITEM_TOKEN_PRIVILEGE_EDIT = 0
 * ITEM_TOKEN_PRIVILEGE_READ_ONLY = 1
 * ITEM_TOKEN_PRIVILEGE_CLAIM = 2
 */
export const PRIVILEGE_KEYS = {
  ALL: 0,        // ITEM_TOKEN_PRIVILEGE_EDIT — Permiso de edicion
  READ_ONLY: 1,  // ITEM_TOKEN_PRIVILEGE_READ_ONLY — Permiso de solo lectura
  CLAIM: 2,      // ITEM_TOKEN_PRIVILEGE_CLAIM — Permiso de denuncia
} as const;

export type PrivilegeValue = typeof PRIVILEGE_KEYS[keyof typeof PRIVILEGE_KEYS]; // 0 | 1 | 2

export const Privileges: Record<PrivilegeValue, 'ALL' | 'READ_ONLY' | 'CLAIM'> = {
  [PRIVILEGE_KEYS.ALL]: 'ALL',
  [PRIVILEGE_KEYS.READ_ONLY]: 'READ_ONLY',
  [PRIVILEGE_KEYS.CLAIM]: 'CLAIM',
};

export const defaultUserPrivilege: PrivilegeValue = PRIVILEGE_KEYS.ALL;
